import Vue from 'vue';
import Router from 'vue-router';

// utils
import isAuthenticated from './utils/auth';

// routes
import authentication from '../modules/authentication/routes';
import dashboard from '../modules/dashboard/routes';
import droneView from '../modules/droneView/routes';

Vue.use(Router);

function redirectHome(to, from, next) {
  if (isAuthenticated()) {
    next('/dashboard');
  } else {
    next();
  }
}

const defaultRoutes = [
  { path: '/api' },
  {
    name: 'default',
    path: '/',
    redirect: '/signin',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../modules/authentication/pages/login/View.vue'),
    beforeEnter: redirectHome,
  },
  {
    path: '/signin',
    name: 'signin',
    component: () => import('../modules/authentication/pages/signin/View.vue'),
    beforeEnter: redirectHome,
  },
  {
    path: '/callback',
    name: 'callback',
    component: () => import('../modules/authentication/pages/callback/View.vue'),
    beforeEnter: redirectHome,
  },
  {
    path: '*', // 404 wildcard
    name: '*',
    component: () => import('../modules/404/View.vue'),
  },
];

const routes = [
  ...defaultRoutes,
  ...authentication,
  ...dashboard,
  ...droneView,
];

const router = new Router({
  mode: 'history',
  routes,
});

// router guards
router.beforeEach((to, from, next) => {
  if (!isAuthenticated()) {
    if (to.name === 'login' || to.name === 'signin' || to.name === 'callback') {
      next();
    } else {
      next({ path: 'signin' });
    }
  } else {
    next();
  }
});

export default router;
